import http from "./http";
import { LIMITE_CATALOGO } from "@/constants/permisos";

/**
 * Service for the roles & permissions panel (Trello #385).
 *
 * Uses the central http instance (baseURL already includes /api/v1/).
 * Unlike older services, every function resolves to response.data so the
 * Vuex module never has to unwrap axios responses.
 */
const permisosService = {
  // ─── Roles ──────────────────────────────────────────────────────────────
  listarRoles: () => http.get("usuarios/roles").then((r) => r.data),
  obtenerRol: (id) => http.get(`usuarios/roles/${id}`).then((r) => r.data),
  crearRol: ({ rol, descripcion }) =>
    http.post("usuarios/roles", { rol, descripcion }).then((r) => r.data),
  actualizarRol: (id, { rol, descripcion, activo }) =>
    http.put(`usuarios/roles/${id}`, { rol, descripcion, activo }).then((r) => r.data),
  eliminarRol: (id) => http.delete(`usuarios/roles/${id}`).then((r) => r.data),
  clonarRol: (id, { rol, descripcion }) =>
    http.post(`usuarios/roles/${id}/clonar`, { rol, descripcion }).then((r) => r.data),

  // ─── Action catalog (paginated) ─────────────────────────────────────────
  listarAcciones: ({ modulo, limite = LIMITE_CATALOGO, desde = 0 } = {}) =>
    http.get("usuarios/acciones", { params: { modulo, limite, desde } }).then((r) => r.data),

  // ─── Actions granted to a role ──────────────────────────────────────────
  obtenerAccionesDeRol: (id) => http.get(`usuarios/roles/${id}/acciones`).then((r) => r.data),
  guardarAccionesDeRol: (id, claves) =>
    http.put(`usuarios/roles/${id}/acciones`, { acciones: claves }).then((r) => r.data),

  // ─── Per-user overrides ([{ clave, tipo: 'grant' | 'deny' }]) ───────────
  obtenerOverrides: (userId) => http.get(`usuarios/${userId}/acciones`).then((r) => r.data),
  guardarOverrides: (userId, items) =>
    http.put(`usuarios/${userId}/acciones`, { overrides: items }).then((r) => r.data),
  cambiarRol: (userId, idRol) =>
    http.put(`usuarios/${userId}/rol`, { id_rol: idRol }).then((r) => r.data),

  // ─── Screens (routes + menus) visible to a role ─────────────────────────
  obtenerPantallasDeRol: (id) => http.get(`usuarios/roles/${id}/pantallas`).then((r) => r.data),
  guardarPantallasDeRol: (id, { rutas, menus }) =>
    http.put(`usuarios/roles/${id}/pantallas`, { rutas, menus }).then((r) => r.data),

  // ─── Effective actions of the authenticated user ────────────────────────
  misAcciones: (modulo) => {
    const params = modulo ? { modulo } : {};
    return http.get("usuarios/me/acciones", { params }).then((r) => r.data);
  },
};

export default permisosService;
